import { render, staticRenderFns } from "./QuestionBank.vue?vue&type=template&id=854f716a&scoped=true&"
import script from "./QuestionBank.vue?vue&type=script&lang=js&"
export * from "./QuestionBank.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBank.vue?vue&type=style&index=0&id=854f716a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854f716a",
  null
  
)

export default component.exports